/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Cies_P2Inputs */

const es_marketplace_seo_galicia_guide_cies_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay salidas desde Vigo, Cangas, Baiona y Sanxenxo: desde paseos de día hasta rutas combinadas con baño y comida a bordo.`)
};

const gl_marketplace_seo_galicia_guide_cies_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai saídas dende Vigo, Cangas, Baiona e Sanxenxo: dende paseos de día ata rutas combinadas con baño e comida a bordo.`)
};

const en_marketplace_seo_galicia_guide_cies_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departures from Vigo, Cangas, Baiona and Sanxenxo range from day trips to routes with swimming and food on board.`)
};

/**
* | output |
* | --- |
* | "Departures from Vigo, Cangas, Baiona and Sanxenxo range from day trips to routes with swimming and food on board." |
*
* @param {Marketplace_Seo_Galicia_Guide_Cies_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_cies_p2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Cies_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Cies_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_cies_p2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_cies_p2(inputs)
	return es_marketplace_seo_galicia_guide_cies_p2(inputs)
});